<template>
  <!-- flex items -->
  <div class="bg-white border rounded-lg overflow-hidden sm:max-w-xs sm:flex-wrap sm:inline-block lg:m-8 shadow-lg m-4">
    <img
      class="object-cover sm:h-48 sm:w-full"
      :src="vendor.image"
      :alt="vendor.name"
    />
    <div class="p-4 text-green-800 tracking-wider">
      <h4 class="font-bold">{{ vendor.name }}</h4>
      <div class="font-hairline mt-3 text-orange-700">{{ vendor.excerpt }}</div>
      <div class="flex flex-row mt-2">
        <div
          class="mr-2"
          v-for="(tag, index) in vendor.tags"
          :key="index"
        >#{{tag}}</div>
      </div>

      <div class="flex flex-row-reverse">
        <router-link :to="`/products/${vendor.user_id}`">
          <button class="mt-4 bg-green-800 hover:bg-green-700 text-white font-bold py-2 px-4 rounded ">
            Einkaufen
          </button>

        </router-link>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["vendor"]
};
</script>
